import type { CheckoutFavicon as GQLItem } from '../generated/checkout.graphql';
import { take } from '../util';

/**
 * One icon slot the host's white-label config declares: a link relation, the sizes it covers and
 * the URL to serve it from. The checkout renders these into `<head>` during `onBeforeRender`,
 * which is why they ride along with the branding lookup rather than the event's account.
 *
 * Deliberately a passthrough of the wire shape. The backend owns which slots a config fills and
 * what it calls them; the checkout renders whatever it is handed, so that onboarding a client
 * needs no frontend change.
 */
export type CheckoutFavicon = {
  rel: string;
  sizes: string;
  url: string;
};

export const fromGql = (item: GQLItem): CheckoutFavicon => take<CheckoutFavicon>(item, 'rel', 'sizes', 'url');

export const fromGqlCollection = (items?: GQLItem[] | null): CheckoutFavicon[] => items?.map(fromGql) || [];
